import type { MenuPeriodURN } from '@library/menu-service'

import { getIsAuthenticated } from 'selectors/auth'
import { getSelectedDeliverySlot, isBasketTransactionalOrder } from 'selectors/basket'
import type { ImmutableMap } from 'utils/types/immutable'

type MenuPeriodState = Parameters<typeof getSelectedDeliverySlot>[0] & {
  auth?: ImmutableMap<{ isAuthenticated: boolean }>
}

export const getMenuPeriodUrn = (state: MenuPeriodState): MenuPeriodURN | undefined => {
  if (!getIsAuthenticated(state) || !isBasketTransactionalOrder(state)) {
    return undefined
  }

  return getSelectedDeliverySlot(state)?.get('menuPeriodUrn')
}
